module.exports = __webpack_public_path__ + "img/fr.ed733e43.svg";